import translations from '../translations/de';
import formatName from './formatName';

const translateLabel = (name) => {
    return translations[name] ? formatName(translations[name]) : formatName(name);
};

export default translateLabel;
